import type { Action } from '@sportybot-web/auth/permissions/permissions';
import type { LinkProps } from '@tanstack/react-router';

import { CirclePlay, Home, type LucideIcon, Search, SquarePen } from 'lucide-react';

export interface NavLink<T extends string = TabPath> {
  icon: LucideIcon;
  label: string;
  // Hides the link if the user does not have the permission
  permissions?: Action;
  to: T;
}

export type TabPath = Extract<LinkProps['to'], '/' | '/clips' | '/rules' | '/search'>;

export const NAV_LINKS: NavLink[] = [
  {
    icon: Home,
    label: 'Home',
    to: '/',
  },
  {
    icon: CirclePlay,
    label: 'Clips',
    to: '/clips',
  },
  {
    icon: SquarePen,
    label: 'Rules',
    permissions: 'CAN_ACCESS_RULES',
    to: '/rules',
  },
  {
    icon: Search,
    label: 'Search',
    to: '/search',
  },
];
